<script lang="ts">
    import {onMount} from "svelte";
    import ButtonView from "./ButtonView.svelte";

    export let text;
    export let url;
    export let isOtherTab = false;

    export let isDisabled = false;
    export let isPrimary = false;
    export let isSmall = false;

    export let fontAwesomeIcon = null;
    export let fontAwesomeClassification = null;

    export let downloadFileName = null;

    $: href = (() => {
        if (isDisabled) {
            return null;
        }
        return url;
    })();

    $: rel = (() => {
        if (isOtherTab) {
            return 'noopener noreferrer';
        } else {
            return '';
        }
    })();

    $: target = (() => {
        if (isOtherTab) {
            return '_blank';
        } else {
            return '';
        }
    })();

    onMount(() => {
    });

    function onClick(event) {
        event.stopPropagation();
    }

</script>

<a class="link-button-view" href={href} rel={rel} target={target} download={downloadFileName}>
    <ButtonView
            isDisabled={isDisabled} isPrimary={isPrimary} isSmall={isSmall}
            text={text}
            fontAwesomeIcon={fontAwesomeIcon} fontAwesomeClassification={fontAwesomeClassification}
            isStopPropagation={false}
            on:click={onClick}
    />
</a>
<style lang="scss">
    .link-button-view {

    }
</style>